/**
 *
 * Coupon
 *
 */

import { mapGetters } from 'vuex';
import $ from 'jquery';

import { LOADING_MESSAGE } from './Coupon.constants';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';

import { REDIRECT_URLS } from '@/constants';

export default {
  name: 'Coupon',

  components: {
    WayFindBar,
    Footer,
    Aside,
    TabBar,
    Spinner,
    PzButton,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
      REDIRECT_URLS,
    };
  },

  computed: {
    ...mapGetters({
      MyCoupons: 'Coupon/MyCoupons',
      userInfo: 'userInfo',
      immLoading: 'immLoading',
      aopLoading: 'aopLoading',
      Used: 'Coupon/Used',
      UnUsed: 'Coupon/UnUsed',
      Expired: 'Coupon/Expired',
    }),
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  created() {
    this.getMyCoupons();
  },

  methods: {
    async getMyCoupons() {
      await this.$store.dispatch('Coupon/getMyCoupons');
      $(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    },
  },
};
